import { Component } from '@angular/core';
var HTML_TEMPLATE = "\n<div class=\"od-my-todo\">My todo</div>\n";
var CSS_STYLE = "\n.od-my-todo {\n}\n";
var MyTodo = /** @class */ (function () {
    function MyTodo() {
    }
    MyTodo.decorators = [
        { type: Component, args: [{
                    selector: 'od-my-todo',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    MyTodo.ctorParameters = function () { return []; };
    return MyTodo;
}());
export { MyTodo };
//# sourceMappingURL=my-todo.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/my-todo/my-todo.js
// module id = 447
// module chunks = 14